<template>
  <section class="form-list">
    <el-form
        ref="form"
        :model="card"
        :rules="isAdministrator ? undefined : rules"
        label-position="right"
        label-width="130px"
        class="form"
    >
      <el-form-item v-if="card.add_time_apply" label="退卡申请时间">{{ card.add_time_apply | timeToYmdHi }}</el-form-item>

      <el-form-item v-if="card.admin_id_apply" label="退卡申请者">
        <v-avatar-nickname
            :value="card.admin_avatar_apply"
            :nickname="card.admin_nickname_apply"
            :is-center="false"
        />
      </el-form-item>

      <el-form-item label="退卡门店">{{ card.store_name_refund }}</el-form-item>

      <el-form-item label="所属学员">
        <v-avatar-nickname
            :value="card.selfie"
            :nickname="card.student_name"
            :is-center="false"
            :link-page-name="RouteConfig.studentDetail.name"
            :link-page-id="card.student_id"
        />
      </el-form-item>

      <el-form-item label="课卡 ID">{{ card.card_id }}</el-form-item>

      <el-form-item label="课卡名称">{{ card.card_name }}</el-form-item>

      <el-form-item label="课卡类型">{{ card.card_type_name }}</el-form-item>

      <el-form-item label="有效次数" v-show="card.is_number_limit">{{ card.expire_number }}</el-form-item>

      <el-form-item label="有效天数">{{ card.expire_days }} 天</el-form-item>

      <el-form-item label="办卡日期">{{ card.register_time | timeToYmd }}</el-form-item>

      <el-form-item label="办卡门店">{{ card.store_name_card }}</el-form-item>

      <el-form-item label="失效日期">{{ card.expire_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="实际付款">{{ card.actual_payment }} 元</el-form-item>

      <el-form-item label="退款金额" prop="del_payment">{{ card.del_payment }} 元</el-form-item>

      <el-form-item label="退卡原因">
        <el-radio v-model="card.is_input_error" :label="0">非录入错误</el-radio>
        <el-radio v-model="card.is_input_error" :label="1">录入错误</el-radio>
        <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入退卡的原因"
            v-model="card.del_remark"
            maxlength="250"
            show-word-limit
        />
      </el-form-item>

      <el-form-item label="退卡原因截图">
        <v-img v-if="card.del_cover" :value="card.del_cover"/>
        <template v-else>-</template>
      </el-form-item>

      <el-form-item label="退卡通过者">
        <v-avatar-nickname
            :value="card.admin_avatar"
            :nickname="card.admin_nickname"
            :is-center="false"
        />
      </el-form-item>
      <el-form-item label="退卡通过时间">{{ card.add_time | timeToYmdHi }}</el-form-item>

      <template v-if="card.admin_id_update">
        <el-form-item label="最近一次修改者">
          <v-avatar-nickname
              :value="card.admin_avatar_update"
              :nickname="card.admin_nickname_update"
              :is-center="false"
          />
        </el-form-item>
        <el-form-item label="最近一次修改时间">{{ card.update_time | timeToYmdHi }}</el-form-item>
      </template>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.cardDeleteApplyList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { applyStates } from "@/enums/applyStates";
import { show, update } from "@/api/card-del-record";
import { toYuan } from "@/filters";

const validateDelRemark = (rule, value, callback) => {
  const error = (!value || value.length < 2) ? new Error('请输入 2 ~ 250 字的退卡原因') : undefined;
  callback(error);
};

export default {
  name: RouteConfig.cardDeleteRecordEdit.name,
  data: () => ({
    RouteConfig,
    applyStates,
    isSaving: false,
    isPassing: false,
    isRejecting: false,
    isRevoking: false,
    isLoading: false,
    isLoadingError: false,
    card: {
      card_id: 0,
      add_time: 0,
      update_time: 0,
      add_time_apply: 0,
      is_reviewing: 0,
      student_id: 0,
      selfie: '',
      student_name: '',
      add_store_name: '',
      card_name: '',
      card_type_name: '',
      expire_number: '',
      expire_days: '',
      register_time: '',
      expire_time: '',
      actual_payment: '',
      apply_state: applyStates.review.value,

      store_name_card: '',
      store_name_refund: '',

      admin_id_apply: 0,
      admin_nickname_apply: '',
      admin_avatar_apply: '',

      admin_id_update: 0,
      admin_nickname_update: '',
      admin_avatar_update: '',

      admin_id: 0,
      admin_nickname: '',
      admin_avatar: '',

      del_cover: '',
      del_payment: 0,
      del_remark: '',
      is_input_error: 0,
    },
    rules: {
      del_remark: [{ required: true, message: '', trigger: 'blur', validator: validateDelRemark }],
    },
  }),
  watch: {
    'card.is_input_error'(value) {
      let { card } = this;
      if (value) {
        if (!card.del_remark) card.del_remark = '录入错误';
      } else {
        if (card.del_remark === '录入错误') card.del_remark = '';
      }
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      if (data.expire_number) data.expire_number = toYuan(data.expire_number);
      if (data.actual_payment) data.actual_payment = toYuan(data.actual_payment);
      if (data.del_payment) data.del_payment = toYuan(data.del_payment);

      const { card } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in card) updateCardInfo[key] = data[key];
      });
      Object.assign(card, updateCardInfo);
      this.isLoading = false;
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { del_remark, is_input_error, update_time } = this.card;

        this.isSaving = true;
        const { isError } = await update(this.id, { update_time, del_remark, is_input_error });
        this.isSaving = false;
        if (isError) return;

        RouteConfig.cardDeletedList.push();
      });
    },
  },
};
</script>
